/**
 * @ngdoc component
 * @name westBerkshireEvents.bookingDetailsList:wbBookingDetailsList
 * 
 * @description 
 * Used for account.html, when viewing past/future bookings, the address is returned without the blank address lines
 */

import bookingDetailsListTemplate from './booking_details_list.template.html';

angular.module('westBerkshireEvents.bookingDetailsList').component('wbBookingDetailsList', {
    templateUrl: bookingDetailsListTemplate.id,
    controller: ['$scope', WbBookingDetailsListController],
    controllerAs: "$bookingDetailsListCtrl",
    bindings: {
        booking: '<'
    }
});

function WbBookingDetailsListController($scope) {

    const self = this;

    self.booking = this.booking;

    // filters through each address line, if the address line is not null then add 
    // it to the array
    this.booking.$getAddress().then(result => {

        let addressParts = [];

        if (result.address1) {
            addressParts.push(result.address1);
        }
        if (result.address2) {
            addressParts.push(result.address2);
        }
        if (result.address3) {
            addressParts.push(result.address3);
        }
        if (result.address4) {
            addressParts.push(result.address4);
        }
        if (result.address5) {
            addressParts.push(result.address5);
        }
        if (result.postcode) {
            addressParts.push(result.postcode);
        }

        self.address = addressParts.join(', ');
    });
}


// WEBPACK FOOTER //
// src/public/javascripts/booking-details-list/booking_details_list.component.js